<template>
	<div class="vip-chart clearfix">
		<div class="vip-chartsResume fl">
			<div class="vip-chartsResumeSee">
				<!-- <p class="vip-chartsResumeSeeTit" >对您感兴趣的企业（昨日:11{{seriesDataResumeSee[6]}}）</p> -->
				<p class="vip-chartsResumeSeeTit">简历被查看次数（昨日:{{analysis.yesterdayBrowseCount}}）</p>
				<!-- <p class="vip-chartsResumeSeeTit" >对您感兴趣的企业</p> -->
				<p class="vip-chartsResumeSeeP">{{analysis.browseCountAdvice}}</p>
			</div>
			<div class="vip-charts">
				<div id="chartResume"></div>
			</div>
			<div class="vip-chartsResumeNote">
				<div class="vip-chartsResumeNoteIn">
					<span class="vip-chartsResumeNoteMe">我</span>
					<span class="vip-chartsResumeNoteLocal">行业平均</span>
				</div>
			</div>
		</div>
		<div class="vip-chartsCompany fr">
			<div class="vip-chartsCompanySee">
				<!-- <p class="vip-chartsCompanySeeTit" >简历被查看次数（昨日:{{seriesDataCompanySee[6]}}）</p> -->
				<p class="vip-chartsCompanySeeTit">对您感兴趣的企业（昨日:{{analysis.yesterdayDownloadCount}}）</p>
				<!-- <p class="vip-chartsCompanySeeTit" >有意向邀约您的企业</p> -->
				<p class="vip-chartsCompanySeeP">{{analysis.downloadCountAdvice}}</p>
			</div>
			<div class="vip-charts">
				<div id="chartCompany"></div>
			</div>
			<div class="vip-chartsCompanyNote">
				<div class="vip-chartsCompanyNoteIn">
					<span class="vip-chartsCompanyNoteMe">我</span>
					<span class="vip-chartsCompanyNoteLocal">行业平均</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
//import echarts from 'echarts'
let echarts = require('echarts/lib/echarts')
//引入柱状图组件
require('echarts/lib/chart/line')
//数据信息浮层
require('echarts/lib/component/tooltip')
import { mapGetters, mapActions } from 'vuex'
export default {
	name: 'ResumeChart',
	props: [],
	computed: mapGetters({
		cvipMes: 'cvipMes'
	}),
	data () {
		return {
			analysis:'',
			/*analysis:{
				jobSeekingData:[
				{
					date:1,
					browseCount:12,
					industryBrowseCount:1,
					downloadCount:1,
					industryDownloadCount:2
				},
				{
					date:2,
					browseCount:1,
					industryBrowseCount:6,
					downloadCount:6,
					industryDownloadCount:6
				},
				{
					date:3,
					browseCount:2,
					industryBrowseCount:3,
					downloadCount:1,
					industryDownloadCount:1
				}

				]
			},*/
			xAxisData: [],
			seriesDataResumeSee: [],
			seriesDataResume: [],
			seriesDataCompanySee: [],
			seriesDataCompany: []
		}
	},
	methods: {
		randerChart (id) { 
			var h_size = parseInt(document.getElementsByTagName('html')[0].style.fontSize)
			this.chart = echarts.init(document.getElementById(id))
			this.chart.showLoading()
			var option = {
				color: ['#4886FF','#EE0035'],
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'line',
						lineStyle: {
							color: '#D4B277',
							width: 1,
						}
					},
					formatter (params) {
						var res = `<div class='chart_tip clear'>
							<div class='time'>${params[0].axisValue}</div>
							<div class='data'><span class='blue'></span>行业平均：${params[0].value}</div>
							<div class='data'><span class='red'></span>简历被查看次数：${params[1].value}</div>
						</div>`
						return res
					}
				},
				dataZoom: {
					show: false,
					realtime: true,
					start: 0,
					end: 100,
					fillerColor: '#FFBB80',
					handleColor: '#D0AD71'
				},
				xAxis: [
					{
						type : 'category',
						axisTick: {
							show: false
						},
						splitLine: {
							lineStyle: {
								color: "#D0AD71",
								type: 'dashed',
								width: 3
							}
						},
						axisLine: {
							lineStyle: {
								color: '#ddd',
								width: 1
							},
						},
						axisLabel: {
							textStyle: {
								color: "#aaa",
								fontSize: 12,
								fontFamily: 'Microsoft YaHei',
							},
							margin: 8,
							interval:0,
						},
						data : this.xAxisData
					}
				],
				yAxis: [
					{
						type : 'value',
						// scale:true,
						axisLine: {
							show: false,
							lineStyle: {
								color: '#ddd',
								width: 1
							}
						},
						splitLine: {
							lineStyle: {
								color: "#E0E0E0;",
								type: 'solid',
								width: 1
							}
						},
						axisLabel: {
							show: true,
							textStyle: {
								color: "#aaa",
								fontSize: 12,
								fontFamily: 'Microsoft YaHei',
							},
							margin: 10,
							interval:0,
						},
					}
				],
				grid: {
					left: 30,
					top: 24,
					width: '90%',
					height: '75%',
					borderWidth: 0
				},
				series: [
					{
						name: '本地同行平均',
						type: 'line',
						symbolSize: 0,
						lineStyle: {
							normal: {
								color: '#1EC8EA',
								width: 0
							}
						},
						areaStyle: {
							normal: {
								color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
									offset: 0,
									color: ' #FFBB80'
								}, {
									offset: 1,
									color: 'rgba(255,226,183,0.33)'
								}])
							}
						},
						smooth: true,
						data: this.seriesDataResume
					},
					{
						name: '简历被查看次数',
						type: 'line',
						symbolSize: 0,
						lineStyle: {
							normal: {
								color: '#D4B277',
								width: 3
							}
						},
						smooth: true,
						data: this.seriesDataResumeSee
					},
				]
			};
			option.xAxis[0].axisLabel.textStyle.fontSize = 24 / 75 * h_size
			option.yAxis[0].axisLabel.textStyle.fontSize = 24 / 75 * h_size
			// option.series[1].lineStyle.normal.width = 6 / 75 * h_size
			this.chart.setOption(option)
			this.chart.hideLoading()
		},
		randerChartCompany (id) { 
			var h_size = parseInt(document.getElementsByTagName('html')[0].style.fontSize)
			this.chart = echarts.init(document.getElementById(id))
			this.chart.showLoading()
			var option = {
				color: ['#4886FF','#EE0035'],
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'line',
						lineStyle: {
							color: '#D4B277',
							width: 1
						}
					},
					formatter: function (params) {
						var res = `<div class='chart_tip clear'>
							<div class='time'>${params[0].axisValue}</div>
							<div class='data'><span class='blue'></span>行业平均：${params[0].value}</div>
							<div class='data'><span class='red'></span>对你感兴趣的企业：${params[1].value}</div>
						</div>`
						return res
					}
				},
				dataZoom: {
					show: false,
					realtime: true,
					start: 0,
					end: 100,
					fillerColor: 'rgba(128,183,249,0.2)',
					handleColor: '#4B89FF'
				},
				xAxis: [
					{
						type : 'category',
						axisTick: {
							show: false
						},
						splitLine: {
							lineStyle: {
								color: "#D0AD71",
								type: 'dashed',
								width: 1
							}
						},
						axisLine: {
							lineStyle: {
								color: '#ddd',
								width: 1
							},
						},
						axisLabel: {
							textStyle: {
								color: "#aaa",
								fontSize: 12,
								fontFamily: 'Microsoft YaHei',
							},
							margin: 8,
						},
						data: this.xAxisData
					}
				],
				yAxis: [
					{
						type: 'value',
						// scale:true,
						axisLine: {
							show: false,
							lineStyle: {
								color: '#ddd',
								width: 1
							}
						},
						splitLine: {
							lineStyle: {
								color: "#E0E0E0",
								type: 'solid',
								width: 1
							}
						},
						axisLabel: {
							show: true,
							textStyle: {
								color: "#aaa",
								fontSize: 12,
								fontFamily: 'Microsoft YaHei',
							},
							margin: 10
						},
					}
				],
				grid: {
					left: 30,
					top: 24,
					width: '90%',
					height: '75%',
					borderWidth: 0,
				},
				series: [
					{
						name: '行业平均',
						type: 'line',
						symbolSize: 0,
						lineStyle: {
							normal: {
								color: '#FFBB80',
								width: 0
							}
						},
						areaStyle: {
							normal: {
								color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
									offset: 0,
									color: '#FFBB80'
								}, 
								{
									offset: 1,
									color: 'rgba(255,226,183,0.33)'
								}])
							}
						},
						smooth: true,
						data: this.seriesDataCompany
					},
					{
						name: '对你感兴趣的企业',
						type: 'line',
						symbolSize: 0,
						lineStyle: {
							normal: {
								color: '#D4B277',
								width: 3
							}
						},
						smooth: true,
						data: this.seriesDataCompanySee
					},
				]
			};
			option.xAxis[0].axisLabel.textStyle.fontSize = 24 / 75 * h_size
			option.yAxis[0].axisLabel.textStyle.fontSize = 24 / 75 * h_size
			// option.series[1].lineStyle.normal.width = 6 / 75 * h_size
			this.chart.setOption(option)
			this.chart.hideLoading()
		},
		chartData () {
			for (let v of this.analysis.jobSeekingData) {
				this.xAxisData.push(v.date)
				this.seriesDataResumeSee.push(v.browseCount)
				this.seriesDataResume.push(v.industryBrowseCount)
				this.seriesDataCompanySee.push(v.downloadCount)
				this.seriesDataCompany.push(v.industryDownloadCount)
			}
		}
	},
	created () {
		this.analysis=this.cvipMes.analysis
		this.chartData()
		this.$nextTick(function () {
			this.randerChart('chartResume')
			this.randerChartCompany('chartCompany')
		})
	},
}
</script>

<style lang="scss" scope>
@import "../../../../../assets/css/public.scss";
	.vip-chart {
		margin-top:10px;
	}
	.vip-chartsCompany,
	.vip-chartsResume {
		padding: 25px;
		width: 540px;
		height: 378px;
		background: #fff;
	}
	.chart_tip .blue,
	.chart_tip .red {
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		margin: auto;
	}
	#chartResume .blue {
		width: px2rem(30px);
		height: px2rem(15px);
		opacity: 0.44;
		filter: progid:DXImageTransform.Microsoft.Gradient(startColorStr='#FFBB80',endColorStr='rgba(255,226,183,0.33)',gradientType='0');
		background-image: -webkit-linear-gradient(#FFBB80 50%, rgba(255,226,183,0.33) 100%);
		background-image: -o-linear-gradient(#FFBB80 50%, rgba(255,226,183,0.33) 100%);
		background-image: -moz-linear-gradient(#FFBB80 50%, rgba(255,226,183,0.33) 100%);
		background-image: linear-gradient(#FFBB80 50%, rgba(255,226,183,0.33) 100%);
	}
	#chartResume .red {
		background: #908DFC;
		width: px2rem(30px);
		height: px2rem(6px);
	}
	#chartCompany .blue {
		width: px2rem(30px);
		height: px2rem(15px);
		opacity: 0.44;
		filter: progid:DXImageTransform.Microsoft.Gradient(startColorStr='#FFBB80',endColorStr='rgba(255,226,183,0.33)',gradientType='0');
	  background-image: -webkit-linear-gradient(#FFBB80 50%, rgba(255,226,183,0.33) 100%);
	  background-image: -o-linear-gradient(#FFBB80 50%, rgba(255,226,183,0.33) 100%);
	  background-image: -moz-linear-gradient(#FFBB80 50%, rgba(255,226,183,0.33) 100%);
	  background-image: linear-gradient(#FFBB80 50%, rgba(255,226,183,0.33) 100%);
	}
	#chartCompany .red {
		background: #908DFC;
		width: px2rem(30px);
		height: px2rem(6px);
	}
	
	#chartResume {
		margin: 0 auto;
		width: 540px;
		height: 300px;
	}
	#chartCompany {
		margin: 0 auto;
		width: 540px;
		height: 300px;
	}
	.vip-charts {
		background: #fff;
	}
	.vip-chartsResumeSeeTit,
	.vip-chartsCompanySeeTit {
		font-size: 16px;
		color: #333;
		font-weight: bold;
	}
	.vip-chartsResumeSeeP,
	.vip-chartsCompanySeeP {
		margin-top: px2rem(4px);
		font-size: 12px;
		color: #999;
		opacity: .7;
	}
	.vip-chartsResumeNote,
	.vip-chartsCompanyNote {
		width: 100%;
		background: #fff;
	}
	.vip-chartsResumeNoteIn,
	.vip-chartsCompanyNoteIn {
		margin:0 auto;
		width: 210px;
	}
	.vip-chartsResumeNoteMe,
	.vip-chartsCompanyNoteMe {
		display: inline-block;
		margin: 10px 80px 0 0 ;
		padding-left: 40px;
		position: relative;
		font-size: 12px;
		color: #aaa;
	}
	.vip-chartsResumeNoteMe:before,
	.vip-chartsCompanyNoteMe:before {
		position: absolute;
		top: 45%;
		left: 0;
		content: "";
		width: 26px;
		height: 6px;
		background: #D4B277;
		border-radius: 100px;
	}
	.vip-chartsResumeNoteLocal,
	.vip-chartsCompanyNoteLocal {
		display: inline-block;
		position: relative;
		font-size: 12px;
		color: #aaa;
	}
	.vip-chartsResumeNoteLocal:before,
	.vip-chartsCompanyNoteLocal:before {
		position: absolute;
		top: 36%;
		left: -40px;
		content: "";
		width: 26px;
		height: 6px;
		background: #FFD7BD;
		border-radius: 100px;
	}
</style>



// WEBPACK FOOTER //
// ResumeChart.vue?6b99d69f